module.exports = __webpack_public_path__ + "static/hyperv_44.e4b54e2e.png";